import React from 'react'
import styles from './BottomNavigation.module.css'
import watchlistIcon from '../../../assets/image/dashboard-images/watchlist.png'
import tradeIcon from '../../../assets/image/dashboard-images/trade.png'
import homeIcon from '../../../assets/image/dashboard-images/home.png'
import searchIcon from '../../../assets/image/dashboard-images/search.png'
import addIcon from '../../../assets/image/dashboard-images/add.png'

const BottomNavigation = (props) => {
    return (
        <div className={props.showHeader ? styles.bottom_nav_container : styles.hide}>
            <div className={`${styles.bottom_nav} navbar`}>
                <div className={styles.nav_container}>
                    {/* Watchlist */}
                    <button className={styles.nav_btn}>
                        <img src={watchlistIcon} alt="" />
                        <span>Watchlist</span>
                    </button>

                    {/* Trade */}
                    <button className={styles.nav_btn}>
                        <img src={tradeIcon} alt="" />
                        <span>Trade</span>
                    </button>

                    {/* Center Button */}
                    <div className={styles.center_slot}>
                        <button className={`${styles.nav_btn} ${styles.center_btn}`} onClick={props.onBackToDashboard}>
                            <img src={homeIcon} alt="" />
                        </button>
                    </div>

                    {/* Search */}
                    <button className={styles.nav_btn}>
                        <img src={searchIcon} alt="" />
                        <span>Search</span>
                    </button>

                    {/* Add */}
                    <button className={styles.nav_btn}>
                        <img src={addIcon} alt="" />
                        <span>Add</span>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default BottomNavigation